



import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import BrandHeader from "./BrandHeader"; // Assuming BrandHeader is a separate component
import Navbar from "./Navbar"; // Assuming Navbar is a separate component

const BrandPendingRequest = () => {
  const [formData, setFormData] = useState({
    message: "", // Key remains "message"
    category: "",
    language: "",
    location: "",
    platform: "", // Empty by default
    influencerCount: "",
    influencerFollowersCount: "", // Follower count dropdown
    budget: "",
    youtubeCount: 0, // Default value for youtubeCount set to 0
  });

  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("Brandtoken");
    if (!token) {
      navigate('/BrandLogin');
      return;
    }
  }, [navigate]);

  const brandId = localStorage.getItem("brandID");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Override youtubeCount to 0 just in case it's changed by the users
    const dataToSubmit = { ...formData, youtubeCount: 0 };

    try {
      const response = await fetch(
        `https://server-side-influencer.onrender.com/brand/message/${brandId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(dataToSubmit),
        }
      );

      const data = await response.json();

      if (response.ok) {
        toast.success("Your request has been submitted successfully!");
      } else {
        const errorMessage = data.error || "Failed to submit the request. Please try again.";
        toast.error(errorMessage);
      }
    } catch (error) {
      const errorMessage = error.message || "An unexpected error occurred. Please try again.";
      toast.error(errorMessage);
    }
  };

  return (
    <div className="flex h-screen mb-0 justify-center items-center w-full">
      {/* Navbar with higher z-index */}
      <div className="text-white fixed top-0 left-0 bottom-0 z-50">
        <Navbar />
      </div>

      {/* BrandHeader - Positioned absolutely at the top and behind Navbar */}
      <div className="absolute top-0 left-0 w-full z-10 ml-0">
        <BrandHeader page="influencer requirement" />
      </div>

      {/* Main Content Area */}
      <div className="ml-0 sm:ml-1 w-full max-w-3xl h-full relative z-0 mt-[80px]">
        {/* My Request Button - Positioned at the top-right corner of the screen */}
        <button
          onClick={() => navigate('/myrequest')} // Navigate to a specific pages
          className="absolute top-[39px] right-5 bg-gradient-to-br from-purple-600 to-blue-500 text-white py-2 px-4 rounded-full shadow-lg hover:bg-gradient-to-bl focus:outline-none focus:ring-4 focus:ring-blue-300 dark:focus:ring-blue-800 text-xs sm:text-sm mt-5 ml-5"
          style={{ marginTop: '12px' }} // Inline CSS for margin-top
        >
          My Requirements
        </button>

        {/* Form Section */}
        <section className="bg-white dark:bg-gray-900 py-8 px-4 mx-auto max-w-2xl lg:py-16 mt-12" style={{ marginLeft: '44px' }}>
          {/* <h2 className="mb-4 text-xl font-bold text-gray-900 dark:text-white text-center mt-5">
            Add your post requirement for influencers
          </h2> */}

    <h2 className="mb-4 text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold text-gray-900 dark:text-white text-center mt-5 mb-8">
  Add your post requirement for influencers
</h2>


          <form onSubmit={handleSubmit}>
            <div className="grid gap-4 sm:grid-cols-2 sm:gap-6 mt-8">
              {/* Iterate through form data keys to create input fields */}
              {Object.keys(formData).map((key) => {
                // For 'platform', render a dropdown instead of input
                if (key === "platform") {
                  return (
                    <div key={key} className="w-full">
                      <label htmlFor={key} className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        Platform
                      </label>
                      <select
                        name={key}
                        id={key}
                        value={formData[key]}
                        onChange={handleChange}
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                        required
                      >
                        <option value="">Select a platform</option>
                        <option value="Instagram">Instagram</option>
                        <option value="YouTube">YouTube</option>
                        <option value="TikTok">TikTok</option>
                        <option value="Other">Other</option>
                      </select>
                    </div>
                  );
                }

                if (key === "influencerFollowersCount") {
                  return (
                    <div key={key} className="w-full">
                      <label htmlFor={key} className="block mb-2 text-xs font-medium text-gray-900 dark:text-white">
                        Follower Count
                      </label>
                      <select
                        name={key}
                        id={key}
                        value={formData[key]}
                        onChange={handleChange}
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                        required
                      >
                        <option value="">Select follower Range</option>
                        <option value="Nano (1k-10k)">Nano (1k-10k)</option>
                        <option value="Micro (10k-50k)">Micro (10k-50k)</option>
                        <option value="Macro (50k-200k)">Macro (50k-200k)</option>
                        <option value="Mega (200k-1M)">Mega (200k-1M)</option>
                        <option value="Celebrity (1M+)">Celebrity (1M+)</option>
                      </select>
                    </div>
                  );
                }

                if (key === "influencerCount") {
                  return (
                    <div key={key} className="w-full">
                      <label htmlFor={key} className="block mb-2 text-xs font-medium text-gray-900 dark:text-white">
                        Number of Influencers
                      </label>
                      <input
                        type="text"
                        name={key}
                        id={key}
                        value={formData[key]}
                        onChange={handleChange}
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                        placeholder="Enter number of influencers"
                        required
                      />
                    </div>
                  );
                }

                // Hide youtubeCount field from the UI, so it won't appears
                if (key === "youtubeCount") {
                  return null;
                }

                return (
                  <div key={key} className="w-full">
                    <label htmlFor={key} className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                      {key === "message" ? "Campaign Brief" : key.charAt(0).toUpperCase() + key.slice(1)}
                    </label>
                    <input
                      type="text"
                      name={key}
                      id={key}
                      value={formData[key]}
                      onChange={handleChange}
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                      placeholder={key === "message" ? "Enter your campaign brief" : key.charAt(0).toUpperCase() + key.slice(1)}
                      required
                    />
                  </div>
                );
              })}
            </div>

            <button
              type="submit"
              className="inline-flex items-center px-5 py-2.5 mt-4 sm:mt-6 text-sm font-medium text-center text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg"
            >
              Submit Request
            </button>
          </form>
        </section>
      </div>

      <ToastContainer />
    </div>
  );
};

export default BrandPendingRequest;
